export default __webpack_public_path__ + "static/media/colors-1920w.20c489cd.png";